var map = {
	"./image1.png": 11736,
	"./image2.png": 42346,
	"./image3.png": 31329,
	"./image4.png": 75478,
	"./image5.png": 1709,
	"./image6.png": 54502,
	"./image7.png": 45184,
	"./image8.png": 55323
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83668;